<template>
  <b-card>
    <div class="card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="control-label">Geolocalizzazione {{address}}</label>
            <gmap-map
              :center="center"
              :zoom="12"
              ref="mapContainer"
              style="width:100%;  height: 400px;"
            >
            </gmap-map>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="control-label">Coordinate</label>

            <div class="row">
            <div class="input-group col">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  Lat:
                </span>
              </div>
              <input type="text" class="form-control" v-model="latitude" />
            </div>
            <div class="input-group col">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  Lng:
                </span>
              </div>
              <input type="text" class="form-control" v-model="longitude" />
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
let instance = this

export default {
  name: "Geocoding",
  props: [ 'address' ],
  mounted() {
    this.$refs.mapContainer.$mapPromise.then( (map) => {
      this.mapReady = true
      this.geocoder = new google.maps.Geocoder();
      this.map = map
      map.setOptions({
        draggable: true,
        zoomControl: true,
        scrollwheel: false,
        disableDoubleClickZoom: false
      });
    })
  },
  data() {
    return {
      center: { lat: 45.508, lng: 9.587 },
      latitude: 0,
      longitude: 0,
      geocoder: null,
      map: null,
      marker: null
    }
  },
  methods: {
    codeAddress() {
      let to = setTimeout(() => {
        clearTimeout(to)
        this.geocoder.geocode( { 'address': this.address }, (results, status) => {
          if (status == 'OK') {
            this.map.setCenter(results[0].geometry.location);
            if(this.marker == null) {
              this.marker = new google.maps.Marker({
                  map: this.map,
                  position: results[0].geometry.location,
                  draggable: true
              });
              this.marker.addListener('dragend', () => {
                this.map.setCenter(this.marker.getPosition());
                this.latitude = this.marker.getPosition().lat()
                this.longitude = this.marker.getPosition().lng()
                this.$emit("geocoded", { lat: this.latitude, lng: this.longitude })
              });
            } else {
              this.marker.setPosition(results[0].geometry.location)
            }
            this.latitude = this.marker.getPosition().lat()
            this.longitude = this.marker.getPosition().lng()
            this.$emit("geocoded", { lat: this.latitude, lng: this.longitude })
          } else {
            console.log('Geocode was not successful for the following reason: ' + status);
          }
        })
      }, 1000)
    }
  },
  watch: {
    address(value) {
      this.codeAddress()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Sites/Geocoding.vue